import { ArticleLayout } from '../-components/article-layout.tsx';

import heroImageAvifSrc from './hero-image.avif';
import heroImageWebpSrc from './hero-image.webp';
import { articleMeta } from './meta.ts';

export default function Page() {
  return (
    <ArticleLayout
      meta={articleMeta}
      hero={
        <picture>
          <source srcSet={heroImageAvifSrc} type="image/avif" />
          <img
            src={heroImageWebpSrc}
            alt={articleMeta.thumbAlt}
            fetchPriority="high"
            width={2360}
            height={1326}
            className="w-full rounded-2xl"
          />
        </picture>
      }
    >
      <p>
        Har du kredittkortgjeld, smålån og forbrukslån hos flere ulike aktører? Da betaler du trolig
        langt mer i rente enn nødvendig. Du trenger ikke eie bolig for å gjøre noe med det.
        Refinansiering uten sikkerhet lar deg samle dyr gjeld i ett lån, med én rente og én faktura
        i måneden.
      </p>

      <h2>Hva er refinansiering uten sikkerhet?</h2>
      <p>
        Refinansiering uten sikkerhet betyr at du tar opp et nytt, usikret lån for å betale ned
        kredittkortgjeld, smålån og forbrukslån. Du stiller ikke pant i bolig, lånet vurderes ut fra
        inntekt, gjeld og betalingshistorikk.
      </p>
      <p>
        Kredittkort har ofte effektiv rente på 20–30 %, mens et refinansieringslån uten sikkerhet
        typisk ligger fra rundt 8-12 % for de med god kredittscore. Forskjellen kan bety flere tusen
        kroner spart i året.
      </p>

      <h2>Hvem kvalifiserer?</h2>
      <div>
        <ul>
          <li>
            <strong>Fast inntekt:</strong> Lønn, uføretrygd eller annen stabil inntektskilde
          </li>
          <li>
            <strong>Alder:</strong> Vanligvis fra 18 til 75 år, avhengig av långiver
          </li>
          <li>
            <strong>Ren betalingshistorikk:</strong> Uten aktive inkassosaker eller alvorlige
            anmerkninger
          </li>
          <li>
            <strong>Håndterbar gjeldsgrad:</strong> Banken skal se at du kan betjene den nye
            kostnaden
          </li>
        </ul>
        <br />

        <p>
          <u>
            Norske banker er lovpålagt å bare innvilge refinansiering dersom det faktisk blir
            billigere for deg enn gjelden du har i dag.
          </u>
        </p>
      </div>

      <h2>Eksempel: Hva kan du spare?</h2>
      <p>
        150 000 kroner spredt på kredittkort og smålån med snitt 25 % rente koster deg rundt 37 500
        kroner i året. Samler du dette i ett lån med 9 % effektiv rente, faller kostnaden til rundt
        13 500 kroner. Dette blir faktisk en besparelse på cirka 24 000 kroner årlig, bare i renter.
      </p>

      <h2>Slik foregår søknadsprosessen hos oss:</h2>
      <ol>
        <li>
          <strong>Vi henter inn informasjon fra gjeldsregisteret</strong>, og du får full oversikt
          over all gjeld, saldo og rente.
        </li>
        <li>
          <strong>Vi sjekker kredittscoren din</strong>, høyere score gir bedre betingelser.
        </li>
        <li>
          <strong>Vi innhenter tilbud fra flere banker</strong>, slik at du kan sammenligne tilbud
          fra flere banker samtidig. Husk å se på effektiv rente, ikke bare nominell rente.
        </li>
        <li>
          <strong>Du velger det beste tilbudet for deg</strong>, signere og pengene går rett til å
          innfri gammel gjeld, og du sitter igjen med én forpliktelse.
        </li>
      </ol>

      <h2>Er dette noe for deg?</h2>
      <p>
        Passer godt for deg med dyr kredittkort- eller forbruksgjeld som ikke eier bolig eller ikke
        vil stille den som sikkerhet. Med stabil inntekt og håndterbar gjeldsgrad er dette en av de
        enkleste måtene å kutte rentekostnadene på.
      </p>
    </ArticleLayout>
  );
}
